import React, { FC } from "react";
import { Tabs, TabList, Tab, TabsProps } from "@chakra-ui/react";

interface Props<T> {
  options: T[];
  onChange: (option: T) => void;
  getLabel: (option: T) => string;
  colorScheme?: string;
  activeOption?: T;
}

export const LabeledSwitch: FC<
  Props<unknown> & Omit<TabsProps, "children" | "onChange">
> = ({
  options,
  onChange,
  getLabel,
  colorScheme = "seaGreen",
  activeOption,
  ...props
}) => {
  const handleTabChange = (index) => {
    onChange(options[index]);
  };

  return (
    <Tabs
      position="relative"
      variant="unstyled"
      bg="sand.100"
      borderColor="sand.300"
      borderWidth="1px"
      p="1"
      rounded="full"
      isFitted
      index={
        activeOption
          ? options.findIndex((option) => option === activeOption)
          : 0
      }
      {...props}
    >
      <TabList position="relative" zIndex="1">
        {options.map((option, index) => (
          <Tab
            position="relative"
            key={index}
            _focus={{ outline: "none" }}
            _selected={{
              bg: `${colorScheme}.50`,
              borderColor: `${colorScheme}.500`,
              color: `${colorScheme}.500`,
            }}
            _hover={{
              color: `${colorScheme}.500`,
            }}
            borderWidth="1px"
            borderColor="transparent"
            onClick={() => handleTabChange(index)}
            rounded="full"
            py="2"
          >
            {getLabel(option)}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};
